var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-button',{attrs:{"isActive":_vm.isActive.ordered_list(),"icon":'list-ol'},on:{"click":_vm.commands.ordered_list}})}
var staticRenderFns = []

export { render, staticRenderFns }